import React, { useState } from 'react';
import { Check,ContentCopy} from "@mui/icons-material";


function CopyIcon({ text, size = 18 }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (text && document.hasFocus()) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error('Failed to copy:', err);
        });
    }
  };

  return (
    <span
      onClick={handleCopy}
      style={{
        cursor: 'pointer',
        color: copied ? 'green' : 'inherit',
        transition: 'color 0.3s'
      }}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? <Check size={size} /> : <ContentCopy size={size} />}
    </span>
  );
}

export default CopyIcon;